import React from "react";
import { FaCubes, FaFlask, FaHeartbeat, FaProjectDiagram, FaPuzzlePiece } from "react-icons/fa";

const OfferCard = ({ title, subtitle, bullets, coreTech, cta, accent, Icon }) => (
  <div className={`offer-card ${accent || ""}`}>
    <div className="offer-head">
      <div className="offer-title-row">
        {Icon ? <Icon className="offer-title-icon" aria-hidden="true" /> : null}
        <h3 className="offer-title">{title}</h3>
      </div>
      <div className="offer-subtitle">{subtitle}</div>
    </div>

    <ul className="offer-bullets">
      {bullets.map((b, i) => (
        <li key={i}>{b}</li>
      ))}
    </ul>

    <div className="offer-tech">
      <div className="offer-tech-title">Core technologies</div>
      <div className="offer-tech-list">{coreTech.join(" • ")}</div>
    </div>

    <div className="offer-cta">
      <a href="#contact" className="btn btn-sm btn-outline-light">
        {cta}
      </a>
    </div>
  </div>
);

export default function EngagementOptions() {
  return (
    <section id="services" className="engagement-section">
      <div className="container py-5">
        <div className="text-center mb-4">
          <h2 className="text-uppercase">Services</h2>
          <p className="text-muted mb-0">
            Development, stabilization and modernization for business-critical backend platforms.
          </p>
        </div>

        <div className="offer-grid">
          <OfferCard
            accent="accent-blue"
            Icon={FaCubes}
            title="Architecture and Development"
            subtitle="Design and implement reliable backend services for payments, integrations and high-volume processing."
            bullets={[
              "Design robust Java/Kotlin services with clear domain boundaries",
              "Implement reliable sync and async integrations (APIs and event flows)",
              "Deliver cloud-ready services with observability from day one",
            ]}
            coreTech={[
              "Java",
              "Kotlin",
              "Spring Boot",
              "Quarkus",
              "Kafka",
              "REST/OpenAPI",
            ]}
            cta="Discuss architecture & development"
          />

          <OfferCard
            accent="accent-blue"
            Icon={FaFlask}
            title="AI Lab and Prototyping"
            subtitle="Fast PoCs, MVPs and clickable prototypes for AI-driven product ideas."
            bullets={[
              "Build LLM applications: chatbots, knowledge systems and workflow automations",
              "Create RAG pipelines and agent workflows with practical guardrails",
              "Deliver lightweight demo frontends (React/Next.js) for stakeholder validation",
              "Integrate modern AI models (OpenAI, Anthropic, Mistral) based on use case fit",
              "Translate business ideas into visible, testable technical solutions",
              "Work closely with Product Owners, Innovation and domain teams",
            ]}
            coreTech={[
              "Python",
              "TypeScript",
              "React/Next.js",
              "RAG",
              "Agent workflows",
              "OpenAI/Anthropic/Mistral",
            ]}
            cta="Discuss AI prototyping"
          />

          <OfferCard
            accent="accent-red"
            Icon={FaHeartbeat}
            title="Stabilization and Incident Reduction"
            subtitle="Stabilize live 24/7 systems and reduce operational incident pressure."
            bullets={[
              "Analyze failures across service, network and processor boundaries",
              "Harden timeout, retry and circuit-breaker behavior",
              "Improve alert quality, runbooks and recovery workflows",
            ]}
            coreTech={[
              "Java",
              "Kafka",
              "TCP/Netty",
              "Grafana",
              "ServiceNow",
              "Linux",
            ]}
            cta="Discuss stabilization"
          />

          <OfferCard
            accent="accent-green"
            Icon={FaProjectDiagram}
            title="Data & Analytics Integration"
            subtitle="Add data pipelines and analytics capabilities where they improve product decisions."
            bullets={[
              "Build Python pipelines for high-volume event data",
              "Integrate scoring, recommendation or optimization into backend workflows",
              "Define reliability, latency and cost guardrails for production use",
            ]}
            coreTech={[
              "Python",
              "Kafka",
              "Spark/Flink",
              "PostgreSQL",
              "Elasticsearch",
              "Docker/Kubernetes",
            ]}
            cta="Discuss data analytics integration"
          />
        </div>

        <div className="capabilities-box">
          <div className="capabilities-title-row">
            <FaPuzzlePiece className="capabilities-title-icon" aria-hidden="true" />
            <h3 className="capabilities-title">Additional Technical Capabilities</h3>
          </div>
          <p className="capabilities-subtitle mb-0">
            Optional extensions to backend platforms when they create business value.
          </p>
          <ul className="capabilities-list">
            <li>Data analytics and event-processing pipelines</li>
            <li>ML-assisted decision workflows</li>
            <li>LLM and GenAI integration into backend workflows</li>
            <li>Smart-contract & Web3 system integrations</li>
          </ul>
        </div>

          <div className="text-center mt-0 d-flex flex-column align-items-center">
          <div className="cta-group " style={{ marginTop: "2rem" }}>
              <a href="#projects" className="btn-cta2 cta-blue">
                  View projects
              </a>
              <a href="#contact" className="btn-cta2 cta-green">
                  Schedule a call
              </a>
          </div>

          </div>
      </div>
    </section>
  );
}
